// Highcharts draws plot lines on the axis, not as a series, so the legend does
// not show them and the user cannot hide them.
// For each plot line that has an "id" and a "legendName" we add an empty line
// series. The empty series only gives the plot line a legend item. A click on
// that item removes the plot line, or adds it again.
export function plotLineLegendSeries(plotLines) {
  return (plotLines || [])
    .filter((plotLine) => plotLine.id && plotLine.legendName)
    .map((plotLine) => ({
      // A stable id makes Highcharts match this series by id on chart.update.
      // Without it, Highcharts matches by index, and a real data series can
      // inherit the "line" type and the dash style of this legend-only series.
      id: `${plotLine.id}-legend`,
      type: "line",
      name: plotLine.legendName,
      color: plotLine.color,
      dashStyle: plotLine.dashStyle || "shortdash",
      data: [],
      showInLegend: true,
      marker: { enabled: false },
      enableMouseTracking: false,
      dataLabels: { enabled: false },
      events: {
        legendItemClick: function () {
          // "this" is the series. Highcharts runs this handler before it
          // changes the visible state, so "visible" is the state before the
          // click.
          const axis = this.chart.yAxis[0];
          if (this.visible) {
            axis.removePlotLine(plotLine.id);
          } else {
            axis.addPlotLine(plotLine);
          }
        },
      },
    }));
}

export default plotLineLegendSeries;
